"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyWalletProvider = void 0;
const ethers_1 = require("ethers");
class KeyWalletProvider {
    constructor(privateKey) {
        this.type = 'Key';
        this.wallet = new ethers_1.Wallet(privateKey);
        const { address } = this.wallet;
        this.address = address;
    }
    async signMessage(message) {
        return this.wallet.signMessage(message);
    }
}
exports.KeyWalletProvider = KeyWalletProvider;
